import { type ReactElement } from 'react';
import { Button, type NativeButtonProps } from '@ff-it/ui';

export type RemoveButtonProps = Partial<NativeButtonProps>;

export function RemoveButton({
  children,
  icon = 'trash',
  variant = 'ghost',
  size = 'sm',
  ...props
}: RemoveButtonProps): ReactElement {
  return (
    <Button type="button" size={size} icon={icon} variant={variant} {...props}>
      {children}
    </Button>
  );
}
